import Wrapper from './wrapper';
import {
  IWrapper,
  IClientCreateParams,
  IClientUpdateParams,
  IClientListParams,
  IClientListResponse,
} from './types';
import { IClient } from '../types/my-types';

class Client {
  wrapper: IWrapper;

  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  list(params?: IClientListParams) {
    return this.wrapper.client.get<IClientListResponse, IClientListResponse>(`/clients/`, {
      params: { ...params },
    });
  }

  retrieve(id: number) {
    return this.wrapper.client.get<IClient, IClient>(`/clients/${id}/`);
  }

  create(data: IClientCreateParams) {
    return this.wrapper.client.post<IClient, IClient>(`/clients/`, data);
  }

  update(id: number, data: IClientUpdateParams) {
    return this.wrapper.client.patch<IClient, IClient>(`/clients/${id}/`, data);
  }

  del(id: number) {
    return this.wrapper.client.delete<void, void>(`/clients/${id}/`);
  }
}

export default Client;
